const type = 'SET_GENERATED_SPLIT_INVOICE';

const setGeneratedSplitInvoice = (data) => ({
  data,
  type,
});

export { type };
export default setGeneratedSplitInvoice;
